export function removeMarks(node) {
  let newNode = {
    ...node
  };
  delete newNode.marks;
  return newNode;
}
export function removeNonAnnotationMarks(node) {
  let newNode = {
    ...node
  };
  if (node.marks) {
    newNode.marks = node.marks.filter(mark => mark.type === 'annotation');
  }
  return newNode;
}